import { theme } from '@Guidelines/Theme/theme';
import { selectRole } from '@UI/Pages/Administration/Roles/Signals/selectedRoleIdSignal';
import type RoleView from '@UI/Store/Roles/Views/RoleView';
import { css } from '@emotion/react';
import * as React from 'react';

const tabStyle = css`
	display: inline-flex;
	align-items: center;
	border: none;
	padding: 0.625rem 1rem;
	border-radius: ${theme.radii.pill};
	font-family: ${theme.fonts.body};
	font-weight: ${theme.fontWeights.medium};
	font-size: ${theme.fontSizes.medium};
	white-space: nowrap;
	cursor: pointer;
	background-color: ${theme.colors.surfaceMuted};
	color: ${theme.colors.inkSecondary};
`;

const tabActiveStyle = css`
	display: inline-flex;
	align-items: center;
	border: 1.5px solid ${theme.colors.border};
	padding: 0.5625rem 0.9375rem;
	border-radius: ${theme.radii.pill};
	font-family: ${theme.fonts.body};
	font-weight: ${theme.fontWeights.medium};
	font-size: ${theme.fontSizes.medium};
	white-space: nowrap;
	cursor: pointer;
	background-color: ${theme.colors.surface};
	color: ${theme.colors.ink};
`;

type Props = {
	readonly role: RoleView;
	readonly isSelected: boolean;
};

/** Leaf action: selects itself through `selectedRoleIdSignal`'s setter, no callback prop. */
const RoleTab: React.FC<Props> = ({ role, isSelected }) => {
	const handleClick = React.useCallback(() => {
		selectRole(role.id);
	}, [role.id]);

	return (
		<button type="button" css={isSelected ? tabActiveStyle : tabStyle} onClick={handleClick}>
			{role.label} · {role.assignedUserCount}
		</button>
	);
};

export default RoleTab;
